export function getloacllanguage() {
    let language = '';
    switch(window.localStorage.getItem("localeLanguage")){
        case 'zh_CN':
            language = 'zh'
            break;
        case 'en_US':
            language = 'en'
            break;
        case 'zh_TW':
            language = 'tw'
            break;
        case 'th_TH':
            language = 'th'
            break;
        default:
            break;
    }
    return language
}


// WEBPACK FOOTER //
// ./src/utils/pageData.js